import { db, type LocalMovement } from '../db';
import axiosInstance from '../api/axios';

/**
 * Sincroniza los movimientos activos (vehículos actualmente en el parqueadero)
 * desde el servidor a la base de datos local IndexedDB.
 */
export const syncMovementsToLocal = async (companyId: string) => {
    try {
        const response = await axiosInstance.get('/movements/active');
        const activeMovements: any[] = response.data;

        // Limpiar movimientos activos locales previos de esta empresa para evitar duplicados
        // Solo eliminamos los que ya estaban sincronizados para no perder datos pendientes de subida
        await db.movements
            .where({ companyId, status: 'ACTIVO' })
            .delete();

        // Mapear a formato local
        const localMovements: LocalMovement[] = activeMovements.map(m => ({
            id: m.id,
            tipoMovimiento: m.tipoMovimiento as any,
            horaEntrada: m.horaEntrada,
            horaSalida: m.horaSalida,
            placa: m.vehiculo.placa,
            vehiculoId: m.vehiculo.id,
            status: m.status,
            esContrato: m.esContrato,
            synced: true, // Estos vienen del servidor, así que están sincronizados
            companyId: companyId
        }));

        if (localMovements.length > 0) {
            await db.movements.bulkAdd(localMovements);
        }

        console.log(`✅ Synced ${localMovements.length} active movements to IndexedDB`);
        return true;
    } catch (error) {
        console.error('Error syncing active movements:', error);
        return false;
    }
};
